import swal from 'sweetalert'

const getCrop = async (method, body) => {
  const req = await fetch(`${process.env.REACT_APP_API}/list/crop`, {
    method,
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
  if (req.status === 200) {
    const res = await req.json()
    return {
      res
    }
  } else {
    swal('Algo ha salido mal', 'no se pudo obtener los cultivos ', 'error')
  }
}

export default getCrop
